import * as React from 'react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/shadcn/popover';
import { Button } from '@/components/shadcn/button';
import EllipseIcon from '../icons/EllipseIcon';

export interface MoreOptionsKebabProps {
  elements: React.ReactElement<any, any>[];
}

const MoreOptionsKebab: React.FC<MoreOptionsKebabProps> = ({ elements }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open}>
          <EllipseIcon className="fill-neutral-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent>{elements.map(element => element)}</PopoverContent>
    </Popover>
  );
};

export default MoreOptionsKebab;
